import ReactMarkdown from 'react-markdown'

interface MarkdownProps {
  children: string
}

/**
 * Estilos mínimos para que el markdown de la descripción y los comentarios
 * respete la tipografía de CLAUDE.md §6, sin traer una hoja "prose" completa.
 * Los enlaces van en `--text` subrayado, no en `--accent`: el acento se
 * reserva para la acción principal, el foco y el elemento activo (§6), y el
 * texto de un comentario no es ninguna de las tres cosas.
 *
 * `whitespace-pre-line` en párrafos y elementos de lista: en CommonMark un
 * salto de línea simple se funde en un espacio, pero quien escribe en el
 * textarea (o manda la descripción por API) espera verlo como salto. Así se
 * respeta sin exigir dos espacios al final de la línea ni añadir `remark-breaks`.
 */
export function Markdown({ children }: MarkdownProps) {
  return (
    <div className="flex flex-col gap-2 text-body text-text [&_a]:text-text [&_a]:underline [&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-3 [&_blockquote]:text-text-muted [&_code]:rounded [&_code]:bg-surface-hi [&_code]:px-1 [&_code]:font-mono [&_code]:text-meta [&_li]:whitespace-pre-line [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:leading-relaxed [&_p]:whitespace-pre-line [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-5">
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  )
}
